import store from '@/store'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export async function generateAutoclap (dataAnnonce) {
  const data = {}
  data.annonce = dataAnnonce.id
  return HTTP_HYPER_ESPACE_BACKEND
    .post('/clap/autoclap', data)
    .then(response => {
      if (response.request.status === 200) {
        return { type: 'success', message: 'La demande clap a bien été créée', response: response.request.response }
      } else {
        return { type: 'error', message: response.request.response, status: response.request.status }
      }
    }).catch(error => {
      return { type: 'error', message: error }
    })
}

export async function generateClap (dataAnnonce) {
  const sitimmoUser = store.getters.getSitimmoUser
  const data = {}
  data.annonceur_id = dataAnnonce.advertiser.id
  if (dataAnnonce.photos) {
    data.annonce_photos_urls = []
    for (const photo of dataAnnonce.photos) {
      data.annonce_photos_urls.push(photo.url)
    }
  }
  data.annonce_titre = dataAnnonce.titre
  data.annonce_type_objet = dataAnnonce.typeBienLibelle
  if (dataAnnonce.liste_activites_commerce && (dataAnnonce.liste_activites_commerce.length > 0)) {
    data.annonce_type_objet = dataAnnonce.liste_activites_commerce.join('/')
  }
  data.annonce_surface = dataAnnonce.surface_habitable ? dataAnnonce.surface_habitable : dataAnnonce.surface_terrain
  data.annonce_nb_chambres = dataAnnonce.nombre_de_chambres
  data.annonce_nb_pieces_logement = dataAnnonce.nb_pieces_logement
  data.annonce_ville = dataAnnonce.ville
  data.annonce_type_offre = dataAnnonce.typeOffreLibelle
  data.annonce_meuble = dataAnnonce.meuble
  data.annonce_prix = dataAnnonce.prix
  data.annonce_contact_a_afficher = dataAnnonce.contact_a_afficher
  data.annonce_email_a_afficher = dataAnnonce.email_a_afficher
  data.annonce_telephone_a_afficher = dataAnnonce.telephone_a_afficher
  data.annonceur_nom = sitimmoUser.raisonSociale
  data.annonceur_site_url = sitimmoUser.siteWeb
  data.annonceur_logo_url = sitimmoUser.logoUrl
  data.annonceur_adresse = sitimmoUser.adresse + ' ' + sitimmoUser.codePostal + ' ' + sitimmoUser.ville
  data.annonce_id = dataAnnonce.id
  data.annonce_reference = dataAnnonce.reference
  data.annonceur_login = sitimmoUser.login
  data.annonceur_email = sitimmoUser.email
  data.annonceur_telephone = sitimmoUser.telephone
  if (dataAnnonce.sourceCode) {
    data.annonceur_flux = dataAnnonce.sourceCode
  } else if (sitimmoUser.univers === 'IMMO') {
    data.annonceur_flux = 'SAISIE_IMMO'
  } else {
    data.annonceur_flux = 'SAISIE_VO'
  }
  if (sitimmoUser.univers === 'VO') {
    data.annonce_marque = dataAnnonce.marque
    data.annonce_modele = dataAnnonce.modele
    data.annonce_millesime = dataAnnonce.millesime
    data.annonce_version = dataAnnonce.version
    data.annonce_kilometrage = dataAnnonce.kilometrage
  }

  return HTTP_HYPER_ESPACE_BACKEND
    .post('/clap/create', data)
    .then(response => {
      if (response.request.status === 200) {
        return { type: 'success', message: 'La demande clap a bien été créée', response: response.request.response }
      } else {
        return { type: 'error', message: response.request.response, status: response.request.status }
      }
    })
    .catch(error => {
      return { type: 'error', message: error }
    })
}
